import type { PostHogConfig } from 'posthog-js';

import { resolvePostHogHost } from './posthog-client';
import { posthogBeforeSend } from './posthog-before-send';
import { isSessionReplayOptedOut } from './session-replay-preference';

/** Shared PostHog init options for production analytics + monitoring. */
export function buildPostHogInitConfig(): Partial<PostHogConfig> {
  const replayOptOut = typeof window !== 'undefined' && isSessionReplayOptedOut();
  return {
    api_host: resolvePostHogHost(),
    capture_pageview: 'history_change',
    capture_pageleave: true,
    person_profiles: 'identified_only',
    // Cookie-free analytics: localStorage distinct_id only (no PostHog cookie).
    persistence: 'localStorage',
    autocapture: false,
    disable_session_recording: replayOptOut,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask], [data-sensitive], .ph-mask',
      recordCrossOriginIframes: false,
    },
    capture_performance: true,
    capture_exceptions: true,
    before_send: posthogBeforeSend,
  };
}
